const SmallSpinner = ({
  loading = true,
  size = 25,
  margin = 0,
  className = "",
}) => {
  // If the animation data hasn't loaded yet, return null or a fallback

  return (
    <>
      {loading && (
        <div
          className={className}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: `fit-content`,
            width: `${size}px`,
            margin: `${margin}px`,
          }}
        >
          <div className="animate-spin h-4 w-4 border-2 border-gray-400 border-t-transparent rounded-full"></div>
        </div>
      )}
    </>
  );
};

export default SmallSpinner;
